import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './UrgencyMessage.less';
import IconSize from '../../helpers/IconSize';
import {
    getIconProps
} from '../../helpers/helpers';

export default class UrgencyMessage extends Component {
    static propTypes = {
        /** Optional classname to override the root styling */
        className: PropTypes.string,
        /** Sets size and behavior of font and icon */
        size: PropTypes.string,
        /** Data to use in rendering component */
        unitMessage: PropTypes.oneOfType([
            PropTypes.shape({
                iconTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string
                }),
            }),
            PropTypes.shape({
                iconTextV2: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string
                }),
            })
        ]),
        color: PropTypes.bool
    };

    static defaultProps = {
        className: '',
        size: IconSize.MEDIUM,
        unitMessage: {},
        color: false
    };

    render() {
        const {className, size, unitMessage, color} = this.props;

        if (!unitMessage || (!unitMessage.iconTextV1 && !unitMessage.iconTextV2)) {
            return null;
        }

        const {icon, message} = unitMessage.iconTextV1 || unitMessage.iconTextV2;
        const {style, src} = getIconProps(icon, size, color);
        return (
            <div className={`UrgencyMessage ${className}`}>
                <img style={style} src={typeof src === 'function' ? src() : src} alt={icon}/>
                <span className={`UrgencyMessage__text${size === IconSize.SMALL ? '--s' : ''}`}>
                    {message}
                </span>
            </div>
        );
    }
}
